import type { BillDetail } from './types';

export const mockBillDetails: BillDetail[] = [
  {
    id: '1',
    transactionNo: 'TXN202501150001',
    tenantId: 'T10001',
    tenantName: '科技有限公司',
    userId: 'U10001',
    userName: '张三',
    organizationId: 'ORG10001',
    organizationName: '研发部',
    orderNo: 'ORD202501150001',
    billMonth: '2025-01',
    transactionType: '新购',
    paymentMethod: '包年包月',
    consumeTime: '2025-01-15 10:30:25',
    serviceStartTime: '2025-01-15 10:30:25',
    serviceEndTime: '2025-04-15 10:30:25',
    productName: '云电脑标准版',
    resourceConfig: {
      bandwidth: '上行10M,下行10M',
      systemDiskType: 'SSD',
      systemDiskSize: '40G',
      cpu: '8核',
      memory: '16G',
      gpu: 'RTX3060',
    },
    unitPrice: 15000,
    quantity: 2,
    totalAmount: 30000,
    totalPoints: 0,
    discountAmount: 1000,
    discountPoints: 0,
    actualAmount: 29000,
    actualPoints: 0,
    pricingInfo: {
      billingItemId: 'BI10001',
      billingItemName: '云电脑包月套餐',
      billingRuleDescription: '按月计费，3个月起订',
    },
    durationInfo: {
      duration: 3,
      durationUnit: '月',
    },
    paymentType: '余额',
  },
  {
    id: '2',
    transactionNo: 'TXN202501150002',
    tenantId: 'T10002',
    tenantName: '实验中学',
    userId: 'U10002',
    userName: '李四',
    organizationId: '-',
    organizationName: '-',
    orderNo: 'ORD202501150002',
    billMonth: '2025-01',
    transactionType: '新购',
    paymentMethod: '包年包月',
    consumeTime: '2025-01-15 11:20:15',
    serviceStartTime: '2025-01-15 11:20:15',
    serviceEndTime: '2025-07-15 11:20:15',
    productName: '云硬盘标准版',
    resourceConfig: {
      dataDiskType: 'SSD',
      dataDiskSize: '100G',
    },
    unitPrice: 500,
    quantity: 5,
    totalAmount: 0,
    totalPoints: 2500,
    discountAmount: 0,
    discountPoints: 100,
    actualAmount: 0,
    actualPoints: 2400,
    pricingInfo: {
      billingItemId: 'BI10002',
      billingItemName: '云硬盘包月套餐',
      billingRuleDescription: '按月计费，6个月起订',
    },
    durationInfo: {
      duration: 6,
      durationUnit: '月',
    },
    paymentType: '积分',
  },
  {
    id: '3',
    transactionNo: 'TXN202501150003',
    tenantId: 'T10001',
    tenantName: '科技有限公司',
    userId: 'U10001',
    userName: '张三',
    organizationId: 'ORG10002',
    organizationName: '设计部',
    orderNo: 'ORD202501150003',
    billMonth: '2025-01',
    transactionType: '续购',
    paymentMethod: '包年包月',
    consumeTime: '2025-01-15 14:45:30',
    serviceStartTime: '2025-01-15 14:45:30',
    serviceEndTime: '2025-02-15 14:45:30',
    productName: '云电脑高配版',
    resourceConfig: {
      bandwidth: '上行20M,下行20M',
      systemDiskType: 'SSD',
      systemDiskSize: '80G',
      cpu: '16核',
      memory: '32G',
      gpu: 'RTX4090',
    },
    unitPrice: 25000,
    quantity: 1,
    totalAmount: 25000,
    totalPoints: 0,
    discountAmount: 500,
    discountPoints: 0,
    actualAmount: 24500,
    actualPoints: 0,
    pricingInfo: {
      billingItemId: 'BI10003',
      billingItemName: '云电脑包月套餐',
      billingRuleDescription: '按月计费，1个月起订',
    },
    durationInfo: {
      duration: 1,
      durationUnit: '月',
    },
    paymentType: '微信支付',
  },
  {
    id: '4',
    transactionNo: 'TXN202501150004',
    tenantId: 'T10003',
    tenantName: '互联网公司',
    userId: 'U10004',
    userName: '赵六',
    organizationId: 'ORG10003',
    organizationName: '运营部',
    orderNo: 'ORD202501150004',
    billMonth: '2025-01',
    transactionType: '自动续费',
    paymentMethod: '包年包月',
    consumeTime: '2025-01-15 16:25:40',
    serviceStartTime: '2025-01-15 16:25:40',
    serviceEndTime: '2026-01-15 16:25:40',
    productName: '云电脑标准版',
    resourceConfig: {
      bandwidth: '上行10M,下行10M',
      systemDiskType: 'SSD',
      systemDiskSize: '40G',
      cpu: '8核',
      memory: '16G',
      gpu: '无',
    },
    unitPrice: 50000,
    quantity: 1,
    totalAmount: 50000,
    totalPoints: 0,
    discountAmount: 2000,
    discountPoints: 0,
    actualAmount: 48000,
    actualPoints: 0,
    pricingInfo: {
      billingItemId: 'BI10004',
      billingItemName: '云电脑包年套餐',
      billingRuleDescription: '按年计费，1年起订',
    },
    durationInfo: {
      duration: 1,
      durationUnit: '年',
    },
    paymentType: '余额',
  },
  {
    id: '5',
    transactionNo: 'TXN202501150005',
    tenantId: 'T10001',
    tenantName: '科技有限公司',
    userId: 'U10001',
    userName: '张三',
    organizationId: 'ORG10001',
    organizationName: '研发部',
    orderNo: 'ORD202501150005',
    billMonth: '2025-01',
    transactionType: '退订',
    paymentMethod: '包年包月',
    consumeTime: '2025-01-15 17:30:15',
    serviceStartTime: '2025-01-15 10:30:25',
    serviceEndTime: '2025-04-15 10:30:25',
    productName: '云电脑标准版',
    resourceConfig: {
      bandwidth: '上行10M,下行10M',
      systemDiskType: 'SSD',
      systemDiskSize: '40G',
      cpu: '8核',
      memory: '16G',
      gpu: 'RTX3060',
    },
    unitPrice: -15000,
    quantity: 1,
    totalAmount: -15000,
    totalPoints: 0,
    discountAmount: -500,
    discountPoints: 0,
    actualAmount: -14500,
    actualPoints: 0,
    pricingInfo: {
      billingItemId: 'BI10001',
      billingItemName: '云电脑包月套餐',
      billingRuleDescription: '按月计费，3个月起订',
    },
    durationInfo: {
      duration: 3,
      durationUnit: '月',
    },
    paymentType: '余额',
  },
  {
    id: '6',
    transactionNo: 'TXN202501140001',
    tenantId: 'T10002',
    tenantName: '实验中学',
    userId: 'U10002',
    userName: '李四',
    organizationId: '-',
    organizationName: '-',
    orderNo: 'ORD202501140001',
    billMonth: '2025-01',
    transactionType: '新购',
    paymentMethod: '按需购买',
    consumeTime: '2025-01-14 09:15:30',
    serviceStartTime: '2025-01-14 09:15:30',
    serviceEndTime: '2025-01-14 12:15:30',
    productName: '云电脑基础版',
    resourceConfig: {
      bandwidth: '上行5M,下行5M',
      systemDiskType: 'SSD',
      systemDiskSize: '40G',
      cpu: '4核',
      memory: '8G',
      gpu: '无',
    },
    unitPrice: 10,
    quantity: 1,
    totalAmount: 0,
    totalPoints: 30,
    discountAmount: 0,
    discountPoints: 0,
    actualAmount: 0,
    actualPoints: 30,
    pricingInfo: {
      billingItemId: 'BI10005',
      billingItemName: '云电脑按需计费',
      billingRuleDescription: '按小时计费，不足1小时按1小时计算',
    },
    durationInfo: {
      duration: 3,
      durationUnit: '小时',
    },
    paymentType: '积分',
  },
  {
    id: '7',
    transactionNo: 'TXN202501140002',
    tenantId: 'T10003',
    tenantName: '互联网公司',
    userId: 'U10004',
    userName: '赵六',
    organizationId: 'ORG10004',
    organizationName: '技术部',
    orderNo: 'ORD202501140002',
    billMonth: '2025-01',
    transactionType: '新购',
    paymentMethod: '包年包月',
    consumeTime: '2025-01-14 13:40:25',
    serviceStartTime: '2025-01-14 13:40:25',
    serviceEndTime: '2025-01-21 13:40:25',
    productName: '云硬盘高速版',
    resourceConfig: {
      dataDiskType: 'SSD',
      dataDiskSize: '200G',
    },
    unitPrice: 1000,
    quantity: 3,
    totalAmount: 3000,
    totalPoints: 0,
    discountAmount: 100,
    discountPoints: 0,
    actualAmount: 2900,
    actualPoints: 0,
    pricingInfo: {
      billingItemId: 'BI10006',
      billingItemName: '云硬盘包日套餐',
      billingRuleDescription: '按日计费，7天起订',
    },
    durationInfo: {
      duration: 7,
      durationUnit: '日',
    },
    paymentType: '支付宝支付',
  },
  {
    id: '8',
    transactionNo: 'TXN202501130001',
    tenantId: 'T10001',
    tenantName: '科技有限公司',
    userId: 'U10001',
    userName: '张三',
    organizationId: 'ORG10001',
    organizationName: '研发部',
    orderNo: 'ORD202501130001',
    billMonth: '2025-01',
    transactionType: '续购',
    paymentMethod: '包年包月',
    consumeTime: '2025-01-13 10:20:15',
    serviceStartTime: '2025-01-13 10:20:15',
    serviceEndTime: '2025-07-13 10:20:15',
    productName: '云电脑标准版',
    resourceConfig: {
      bandwidth: '上行10M,下行10M',
      systemDiskType: 'SSD',
      systemDiskSize: '40G',
      cpu: '8核',
      memory: '16G',
      gpu: 'RTX3060',
    },
    unitPrice: 15000,
    quantity: 1,
    totalAmount: 90000,
    totalPoints: 0,
    discountAmount: 3000,
    discountPoints: 0,
    actualAmount: 87000,
    actualPoints: 0,
    pricingInfo: {
      billingItemId: 'BI10007',
      billingItemName: '云电脑包月套餐',
      billingRuleDescription: '按月计费，6个月起订',
    },
    durationInfo: {
      duration: 6,
      durationUnit: '月',
    },
    paymentType: '余额',
  },
];
